/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Loader } from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { selectedServicesNew } from "../../Slice/serviceSlice";
import { axiosInstance } from "../../utils/axiosInstance";
import toast from "react-hot-toast";
const Providers = () => {
  const Navigate = useNavigate();
  const data = useSelector((state) => state);
  const dispatch = useDispatch();
  const params = useParams();
  const [serachParams] = useSearchParams();
  localStorage.setItem("category", serachParams?.get("cat"));

  const [providers, setProviders] = useState([]);
  const [loader, setLoader] = useState(false);
  const { Provider } = useSelector((state) => state.auth);
  // const ServiceAvibility = async (id, data) => {
  //   setLoader(true);
  //   await axiosInstance
  //     .get(`category-service?provider_category_detail_id=${id}`)
  //     .then((res) => {
  //       if (res?.data?.data?.length > 0) {
  //         Navigate(`/services/${id}`, { state: data });
  //         setLoader(false);
  //       } else {
  //         toast.error("Service is Not available");
  //         setLoader(false);
  //       }
  //     })
  //     .catch((err) => {
  //       // console.log(err);
  //       setLoader(false);
  //     });
  // };

  useEffect(() => {
    const fetchProviders = async () => {
      setLoader(true);
      await axios
        .get(
          `https://studioapi.dev-sh.xyz/api/provider?category_id=${params.id}`
        )
        .then((res) => {
          setProviders(res.data.data);
          setLoader(false);
        })
        .catch((err) => console.log(err));
    };
    fetchProviders();
  }, [params.id]);

  if (loader) {
    return <Loader />;
  }
  console.log(providers, "prof");
  if (providers.length === 0) {
    return (
      <div className="latest-posts">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {/* Section Title Start */}
              <div className="section-title">
                <h2 className="text-anime">No Providers Found</h2>
              </div>
              {/* Section Title End */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="latest-posts">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            {/* Section Title Start */}
            <div className="section-title">
              <h3 className="wow fadeInUp">Providers</h3>
              <h2 className="text-anime">{serachParams.get("cat")}</h2>
            </div>
            {/* Section Title End */}
          </div>
        </div>
        <div className="row">
          {providers?.map((p, idx) => (
            <div
              className="col-lg-4"
              onClick={() =>
                dispatch(
                  selectedServicesNew({
                    ...Provider,
                    provider_category_detail: p,
                  })
                )
              }
              key={idx}
              style={{ marginBottom: "15px" }}
            >
              {/* Post Item Start */}
              <Link to={`/services/${p.id}`} state={p}>
                <div
                  className="post-item wow fadeInUp"
                  // onClick={() => ServiceAvibility(p?.id, data)}
                  data-wow-delay="0.5s"
                >
                  {/* Post Featured Image Start */}
                  <div className="post-featured-image">
                    {/* <Link to={`/otherservice/${p.id}`} state={p}> */}
                    <figure className="hover-anime">
                      <img
                        src={p.image}
                        alt=""
                        height={300}
                        width={500}
                        style={{ objectFit: "cover" }}
                      />
                    </figure>
                    {/* </Link> */}
                  </div>
                  {/* Post Featured Image End */}
                  {/* Post Header Start */}
                  <div className="post-header">
                    <h3>
                      <Link to={`/services/${p.id}`} state={p}>
                        {p.first_name}
                      </Link>
                    </h3>
                    <div className="post-meta">
                      <ul>
                        <li>
                          <Link to={`/services/${p.id}`} state={p}>
                            {p.about}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* Post Header End */}
                  {/* Post Read More Button Start */}
                  <div className="post-readmore">
                    <Link to={`/services/${p.id}`} state={p}>
                      <img src="assests/images/icon-readmore.svg" alt="" />
                    </Link>
                  </div>
                  {/* Post Read More Button End */}
                </div>
              </Link>
              {/* Post Item End */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Providers;
